<template>
  <div class="NewsDetail">
    <section-header heading="2" ja="「Bépiu.(ベピウ)」「lalamee(ララミー)」で『ディズニー100』イベント開始！" />
    <div>
      <div class="text-area">
        23.04.06<br><br>セガのプリクラでディズニー創立100周年をお祝いしよう！<br>「Bépiu.」「lalamee」で『ディズニー100』イベント実施！<br>ディズニー100
        は、感動と魔法が一生の思い出になる瞬間を祝します。<br><br>
        <center><img src="@/assets/Png/News/D100/D100_01.png" style="max-width: 100%;"></center>
        <br>■実施期間<br>2023年4月6日(木)～2023年5月8日(月)<br><br>■対象機種<br>全国の『Bépiu.（ベピウ）』、『lalamee（ララミー）』<br><br>
        <center><img src="@/assets/Png/News/D100/Kyoutai_Bepiu.png" style="max-width:50%;">
          <img src="@/assets/Png/News/D100/Kyoutai_lalamee.png" style="max-width: 50%;"></center><br><br>
        <center><a href="https://o.puri.jp/appfw/locationBepiu/">Bépiu.を遊べるお店はこちら<br></a><br>
          <a href="https://o.puri.jp/appfw/locationLalamee/">lalameeを遊べるお店はこちら<br></a></center>
        <br><br>■「Bépiu.」と「lalamee」で、それぞれ異なるデザインのディズニー100イベントだよ！<br><br>▼Bépiu.<br><br>
        <center>
          <img src="@/assets/Png/News/D100/D100_02.png" style="max-width: 80%;"></center>
        <br>▼lalamee<br><br>
        <center>
          <img src="@/assets/Png/News/D100/D100_03.png" style="max-width: 80%;"></center>
        <br><br>■ディズニー100イベントの遊び方<br><br>①まずは「イベントモード」を選んでね。<br><br>▼Bépiu.<br><br>
        <center>
          <img src="@/assets/Png/News/D100/D100_04.png" style="max-width: 80%;"></center>
        <br>▼lalamee<br><br>
        <center>
          <img src="@/assets/Png/News/D100/D100_05.png" style="max-width: 80%;"></center>
        <br><br>②撮影後、撮影背景の「フォトカラー」にイベント限定デザインが選べるよ。<br><br>▼Bépiu.<br><br>
        <center>
          <img  src="@/assets/Png/News/D100/D100_06.png" style="max-width: 100%;"></center>
        <br>▼lalamee<br><br>
        <center>
          <img  src="@/assets/Png/News/D100/D100_07.png" style="max-width: 90%;"></center>
        <br><br><br>③らくがき編集画面では、イベント特別デザインのフレームも選べるよ。<br><br>▼Bépiu.<br><br>
        <center>
          <img src="@/assets/Png/News/D100/D100_08.png" style="max-width: 100%;"></center>
        <br>▼lalamee<br><br>
        <center>
          <img src="@/assets/Png/News/D100/D100_09.png" style="max-width: 90%;"></center>
        <br><br>④最後にシールのデザインを選んでね。<br><br>▼Bépiu.<br><br>
        <center>
          <img src="@/assets/Png/News/D100/D100_10.png" style="max-width: 100%;"></center>
        <br>▼lalamee<br><br>
        <center>
          <img src="@/assets/Png/News/D100/D100_11.png" style="max-width: 60%;"></center>
        <br>⑤シールが出てきたら、連動アプリ「プリクラON」で<br>プリデータのダウンロードも忘れずに♪<br>ダウンロードすると、<br>3秒動画「モーメント」も見れるよ！<br>SNSにもアップしてね♪<br><br>プリクラONのカメラで<br>撮影したシールを見ると<br>シールが動く「ARプリクラ」も<br>楽しめるからこちらも試してみてね♪<br>
        <center><br><br>セガ公式SNSでも最新情報を発信中！</center><br><br>ディズニー100
        と一生の思い出になる<br>ストーリーをお祝いしましょう。<br><br>ディズニーファンにはたまらない<br>スペシャルなプリクラを楽しんでね♪<br><br>
        <div class="snsWrapper --snsIcons">
          <a class="snsIcon" href="https://www.instagram.com/sega_purikura/">
            <img src="https://d4.puri.jp/dev/banner/news/Linkicon_01_IG.jpg">
          </a>
          <a class="snsIcon --x" href="https://twitter.com/SEGA_purikura/">
            <img src="@/assets/Png/SNS/Twitter_Social_Icon_Rounded_Square_Color.png">
          </a>
          <a class="snsIcon" href="https://lin.ee/BncFzGc">
            <img src="https://d4.puri.jp/dev/banner/news/Linkicon_03_LINE.jpg">
          </a>
          <a class="snsIcon" href="https://www.tiktok.com/@sega_purikura">
            <img src="https://d4.puri.jp/dev/banner/news/Linkicon_04_TT.jpg">
          </a>
        </div>
        <center>
          <div class="centerBlock">
            <a href="https://www.instagram.com/sega_purikura/">Instagram</a>
            <a href="https://twitter.com/SEGA_purikura/">X(旧Twitter)</a>
            <a href="https://lin.ee/BncFzGc">LINE</a>
            <a href="https://www.tiktok.com/@sega_purikura">TikTok</a>
            <br><br>
          </div>
          <center>
            <img src="@/assets/Png/News/D100/Legal01.png" style="max-width: 30%;">
          </center>
        </center>
      </div>
    </div> <sub-btn @click="onNewsList()">みんなへのお知らせ一覧に戻る</sub-btn>
    <sub-btn @click="onHome()">ホームに戻る</sub-btn>
  </div>
</template>

<script>
import Protobuf from '../mixins/protobuf'
import SectionHeader from "../components/SectionHeader";
import SubBtn from '../components/SubBtn.vue'

export default {
  name: "NewsDetail",
  components: { SectionHeader, SubBtn },
  mixins: [Protobuf],
  data() {
    return {
      title: "",
      img: "",
      description: "",
    }
  },
  methods: {
    onNewsList() {
      this.$router.push('/newsList')
    },
    onHome() {
      this.$router.push('/')
    },
  }
}
</script>

<style lang="scss" scoped>.NewsDetail {
  .text-area {
    margin: 30px 30px 0;
    font-size: 12px;
    color: #373737;

    img {
      max-width: 100%;
    }

    .edge {
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.12);
    }

    p {
      margin-top: 1em;
    }

    .snsIcon {
      display: inline-block;
      height: 67px;
      img {
        height: 67px;
      }
    }
    .--x {
      height: 49px;
      img {
        width: 49px;
        height: 100%;
      }
    }

    .snsWrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &>a:nth-of-type(1){
        margin-right: 15px;
      }
      &>a:nth-of-type(2){
        margin-right: 20px;
      }
    }

    .centerBlock {
      display: flex;
      justify-content: center;

      &>a:not(:last-of-type) {
        margin-right: 30px;
      }

      &>a:last-of-type {
        margin-left: 18px;
      }
    }
  }
}</style>
